import React, { useEffect } from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

/**
 * Toast — kurzlebiger Hinweis für Hintergrund-Aktionen (z. B. fehlgeschlagene
 * optimistische Updates oder Erfolgs-Feedback beim Speichern). Schließt sich
 * nach `duration`ms selbst.
 */
export function Toast({ message, tone = 'critical', duration = 5000, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(() => onDismiss?.(), duration);
    return () => clearTimeout(t);
  }, [message, duration, onDismiss]);

  if (!message) return null;

  const tones = {
    critical: { bg: 'var(--crit-600)',   fg: 'var(--white)' },
    neutral:  { bg: 'var(--ink-700)',    fg: 'var(--white)' },
    secure:   { bg: 'var(--secure-600)', fg: 'var(--white)' },
  };
  const t = tones[tone] || tones.critical;
  const Icon = tone === 'secure' ? CheckCircle2 : AlertCircle;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 1000,
        display: 'flex', alignItems: 'center', gap: 10,
        background: t.bg, color: t.fg,
        padding: '12px 16px', borderRadius: 'var(--radius-md)',
        boxShadow: '0 12px 28px rgba(16,22,35,0.18), 0 4px 10px rgba(16,22,35,0.08)',
        fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', fontWeight: 'var(--fw-semibold)',
        maxWidth: 360,
      }}
    >
      <Icon width={17} height={17} style={{ flexShrink: 0 }} />
      <span>{message}</span>
    </div>
  );
}
